module.exports = __webpack_public_path__ + "static/media/intro.18b8a22e.mp3";